import React, { useEffect } from "react";

/**
 * Hook para deshabilitar el scroll del body cuando show es true
 * @param show boolean - controla si se bloquea o se habilita el scroll
 */

export const useBodyScroll = (showModal: boolean) => {
  useEffect(() => {
    //llamado al scroll
    if (showModal) {
      document.body.style.overflow = "hidden"; // Deshabilita el scroll del body
    } else {
      document.body.style.overflow = "auto"; // Restaura el scroll del body
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);
};
